/**
 * Interruttore generico di un'impostazione del canale (Task 47), stile della
 * shell associativa: etichetta, testo d'aiuto in piccolo e switch accessibile.
 */
import React from 'react';

export interface ChannelSettingToggleProps {
  label: string;
  hint: string;
  checked: boolean;
  disabled?: boolean;
  /** Nome del canale, per distinguere gli interruttori omonimi di canali diversi. */
  channelName?: string;
  onChange: (next: boolean) => void;
}

const ChannelSettingToggle: React.FC<ChannelSettingToggleProps> = ({ label, hint, checked, disabled, channelName, onChange }) => (
  <div className="flex items-start gap-3 py-2">
    <div className="min-w-0 flex-1">
      <p className="text-sm text-gray-800 dark:text-gray-100">{label}</p>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{hint}</p>
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={channelName ? `${label}: ${channelName}` : label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative mt-0.5 inline-flex h-5 w-9 flex-none items-center rounded-full transition-colors disabled:opacity-50 ${
        checked ? 'bg-emerald-600' : 'bg-gray-300 dark:bg-gray-600'
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${
          checked ? 'translate-x-4' : 'translate-x-0.5'
        }`}
      />
    </button>
  </div>
);

export default ChannelSettingToggle;
